import React from "react";
import { Box, Paper, Typography, Skeleton, Chip, Divider } from "@mui/material";
import { AssignmentOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { localizeDateTimeShort } from "utils/dateFormats";

const TYPE_COLOR = {
    Note: "default",
    Call: "primary",
    Meeting: "info",
    Email: "warning",
    Other: "secondary",
};

const stripHtml = (html) => html?.replace(/<[^>]*>/g, "") ?? "";

const MyVendorLeadTasksWidget = ({ tasks = [], isLoading }) => {
    const navigate = useNavigate();

    return (
        <Paper
            onClick={() => navigate("/app/crm/reports/vendor-lead-task-note-list")}
            sx={{
                borderRadius: 5,
                p: 2,
                mt: 1,
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": { transform: "scale(1.01)", boxShadow: 4 },
            }}
            className="bg-orange-50 dark:bg-orange-900 shadow-md"
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h6" fontWeight="bold" className="text-gray-900 dark:text-white">
                    My Tasks
                </Typography>
                <AssignmentOutlined fontSize="large" className="text-orange-500" />
            </Box>
            <Divider sx={{ mb: 1 }} />
            {isLoading ? (
                Array.from({ length: 5 }).map((_, i) => (
                    <Skeleton key={i} height={40} sx={{ borderRadius: 2, mb: 0.5 }} />
                ))
            ) : (
                tasks.map((task) => (
                    <Box
                        key={task._id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        px={1}
                        py={0.75}
                        className="rounded-lg hover:bg-orange-100 dark:hover:bg-orange-800"
                    >
                        <Box display="flex" flexDirection="column">
                            <Typography
                                variant="body2"
                                fontWeight={600}
                                className="text-gray-900 dark:text-white"
                            >
                                {task.vendorLead?.leadId ?? "N/A"}
                            </Typography>
                            <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            >
                                {stripHtml(task.content)}
                            </Typography>
                        </Box>
                        <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.5}>
                            <Chip
                                label={task.type}
                                size="small"
                                color={TYPE_COLOR[task.type] ?? "default"}
                            />
                            <Chip
                                label={task.responded ? "Responded" : "Pending"}
                                size="small"
                                color={task.responded ? "success" : "warning"}
                                sx={{ fontSize: "0.65rem", height: 18 }}
                            />
                            <Typography variant="caption" color="textSecondary">
                                {task.createdAt ? localizeDateTimeShort(task.createdAt) : "N/A"}
                            </Typography>
                        </Box>
                    </Box>
                ))
            )}
        </Paper>
    );
};

export default MyVendorLeadTasksWidget;